import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// element ui
import ElementUI, { Notification, Message } from 'element-ui';
// 默认主题色
// import 'element-ui/lib/theme-chalk/index.css';
// 自定义主题色（通过官网主题色下载）
import './common/el_css/index.css';
Vue.use(ElementUI);
import lang from 'element-ui/lib/locale/lang/en'
import langZh from 'element-ui/lib/locale/lang/zh-CN'
import langZhFan from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'
(function () {
  const types = ["ENG", "简", "繁"];
  let index = types.findIndex(type => type == localStorage.getItem('lang'));
  if (!~index) index = 1;
  const elementTypeNames = [lang, langZh, langZhFan]
  locale.use(elementTypeNames[index])
})()

// custom components
import CPagination from './components/CPagination.vue';
Vue.component('CPagination', CPagination)
import Container from "./components/Container.vue"
Vue.component("Container", Container)

// axios
import { post } from './common/request'
import './common/request'
Vue.prototype.$post = post;

// msg
export const msg = function (title = '', type) {
  /* Notification({
    title,
    type: type == 'e' ? 'error' : 'success'
  }) */
  Message({
    message: title,
    type: type == 'e' ? 'error' : 'success',
    offset: window.innerHeight / 2 - 30,
  })
};
Vue.prototype.$msg = msg;

// 全局事件对象
Vue.prototype.$eventBus = new Vue();

// 环境变量
Vue.prototype.isdev = process.env.NODE_ENV == "development";

const projectConfig = require('./../projectConfig.json')

// 全局混入
Vue.mixin({
  data() {
    return {
      containerMinWidth: "1024px",
      containerMaxWidth: "1400px",
    }
  },
  computed: {
    isLogin() { return !!this.$store.state.token },
    userInfo() { return this.$store.state.userInfo || {} },
    upload_url() { return `${projectConfig.productionHost}/api/v1.login/upload` },
    api_base_url() { return projectConfig.productionHost },
  },
  methods: {
    // 重新获取用户信息
    async resetGetUserInfo() {
      console.debug('重新获取用户信息', this.isLogin)
      if (!this.isLogin) return;
      var res = await this.$post(`v1.user/profile`, {});
      this.$store.commit('saveUserInfo', res.data || {});
    },
    // 复制
    copyFn(str = '') { if (!str) return; this.$copyText(str); this.$msg('复制成功'); },
    // 静默更新数据
    jingmo_update_list(source_list = [], target_list = []) {
      if (target_list.length == 0) source_list.length = 0;
      else {
        source_list.length = target_list.length;
        target_list.map((item, index) => {
          source_list[index] = Object.assign(source_list[index] || {}, item)
        })
      }
      this.$forceUpdate()
    },
  }
});

// 自定义播放器
import MyVideo from "@/components/MyVideo.vue"
Vue.component("MyVideo", MyVideo)

// use copy
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

// 导出插件
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

// 多语言
import i18n from './i18n'
Vue.use(
  {
    i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法,可以实现当点击切换按钮后，elementUI可以自动调用.js语言文件实现多语言切换
  }
)

// 图片懒加载(如果局部页面或容器不想使用图片懒加载可将img样式opacity设为1)
// <img style="width:100px;height:100px;" v-lazy="imageUrl" @load="onImageLoad" alt="Lazy Loaded Image">
// <img v-lazy="imageUrl" @load="onImageLoad" alt="Lazy Loaded Image">
// <img src="@/assets/images/1.png" @load="onImageLoad" alt="Lazy Loaded Image">
import VueLazyload from 'vue-lazyload'
const loadingImg = require('./assets/images/imgLoading.png')
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: 'https://cdn.jsdelivr.net/gh/Alanrk/cleaver@master/static/img/404.png',
  // loading: 'https://cdn.jsdelivr.net/gh/Alanrk/cleaver@master/static/img/loading.gif',
  error: loadingImg,
  loading: loadingImg,
  attempt: 1
})
Vue.mixin({ methods: { onImageLoad(e) { e.target.classList.add('imgLoaded') } } })

// vue 示例
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
